import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastMessages } from '../shared/models/toast-messages';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
  blocking?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private errorToastsSubject = new BehaviorSubject<ToastMessage[]>([]);
  errorToast$ = this.errorToastsSubject.asObservable();
  private blockingSubject = new BehaviorSubject<boolean>(false);
  blocking$ = this.blockingSubject.asObservable();
  private idCounter = 0;
  private currentTimeout?: any;

  show(
    message: string,
    type: ToastType = 'success',
    durationMiliseconds?: number,
    blocking: boolean = false
  ) {
    const currentToasts = this.errorToastsSubject.getValue();


    if (currentToasts.some((t) => t.message === message && t.type === type)) {
      return;
    }

    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
      this.currentTimeout = undefined;
    }
    this.clearAll();
    if (blocking) {
      this.blockingSubject.next(true);
    }
    const toast: ToastMessage = {
      id: ++this.idCounter,
      message,
      type,
      blocking,
    };
    this.errorToastsSubject.next([toast]);
    if (durationMiliseconds && durationMiliseconds > 0) {
      this.currentTimeout = setTimeout(() => this.dismissAll(), durationMiliseconds);
    }
  }

  showInternetErrorMessage() {
    this.show(
      ToastMessages.ERROR_GENERIC,
      'error',
      0
    );
  }

  showCancelOrderSuccessMessage() {
    this.show(
      ToastMessages.SUCCESS_CANCEL_ORDER,
      'success',
      0
    );
  }

  hide() {
    this.dismissAll();
  }
  dismissAll() {
    this.errorToastsSubject.next([]);
  }
  dismiss(id: number) {
    this.errorToastsSubject.next(
      this.errorToastsSubject.getValue().filter((toast) => toast.id !== id)
    );
  }
  unblock() {
    this.blockingSubject.next(false);
    this.dismissAll();
  }
  clearAll() {
    this.errorToastsSubject.next([]);
  }
}
